'use strict';

var ChartDashboardRankingsLegendDirective = function ChartDashboardRankingsLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-rankings-legend.html'),
    controller: 'ChartDashboardRankingsLegendController',
    scope: {
      rankingName: '=',
      screenState: '=',
      mode: '@',
      screen: '@'
    },
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.setDefaultRanking);
    }
  };
};
ChartDashboardRankingsLegendDirective.$inject = [];
module.exports = ChartDashboardRankingsLegendDirective;